<template>

  <div>

<!--    <v-layout class="mb-3">-->

<!--      <v-flex class="text-justify pr-3">-->
<!--        <v-card class="fill-height px-5">-->
<!--          <v-card-text class="title">-->
<!--            <p>Do you need broadband?</p>-->

<!--            <p>Or are you honing in on various broadband services available-->
<!--              at certain locations in the Eastern Sierra?</p>-->

<!--            <p>Use this Service Wizard to <u><i>rapidly</i></u> walk through some needs and-->
<!--              preferences,-->
<!--              and we'll show what options are available!-->
<!--            </p>-->
<!--          </v-card-text>-->
<!--        </v-card>-->
<!--      </v-flex>-->

<!--      <v-flex grow>-->
<!--        <img height="250px" class="" :src="require('../assets/access-close-up-code-1089438.jpg')">-->
<!--        <img height="250px" class=""-->
<!--             :src="require('../assets/computer-daylight-digital-nomad-2773518.jpg')">-->
<!--      </v-flex>-->

<!--    </v-layout>-->

    <h3 class="headline">Use our wizard to estimate your service needs...</h3>

    <WizardUseCategory></WizardUseCategory>

  </div>

</template>

<script>
import WizardUseCategory from '../components/wizard/Wizard.UseCategory';

export default {

  name: 'WizardStart',

  components: { WizardUseCategory },


};

</script>
